module.exports = __webpack_public_path__ + "static/img/1.ea0c1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/1.png
// module id = zoSN
// module chunks = 0